import { createAction } from 'redux-act';

export const fetchSiteMessage = createAction('siteMessage/FETCH_SITE_MESSAGE');
export const setSiteMessages = createAction('siteMessage/SET_SITE_MESSAGES');
export const clearSiteMessages = createAction('siteMessage/CLEAR_SITE_MESSAGES');
